import { render, staticRenderFns } from "./btn-classification.component.vue?vue&type=template&id=3ad79d13"
import script from "./btn-classification.component.vue?vue&type=script&lang=ts"
export * from "./btn-classification.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports